var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedDotAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.01855 0C4.62347 0 4.30427 0.335156 4.30427 0.75V1.2C2.67483 1.54688 1.44717 3.06094 1.44717 4.875V5.31563C1.44717 6.41719 1.06101 7.48125 0.364593 8.30625L0.199417 8.50078C0.0119194 8.72109 -0.0327229 9.0375 0.0811149 9.30703C0.194953 9.57656 0.451646 9.75 0.732892 9.75H9.30421C9.58546 9.75 9.83992 9.57656 9.95599 9.30703C10.0721 9.0375 10.0252 8.72109 9.83768 8.50078L9.67251 8.30625C8.97609 7.48125 8.58993 6.41953 8.58993 5.31563V4.875C8.58993 3.06094 7.36227 1.54688 5.73283 1.2V0.75C5.73283 0.335156 5.41363 0 5.01855 0ZM6.0297 11.5617C6.29755 11.2805 6.4471 10.8984 6.4471 10.5H5.01855H3.59C3.59 10.8984 3.73955 11.2805 4.0074 11.5617C4.27526 11.843 4.63909 12 5.01855 12C5.39801 12 5.76184 11.843 6.0297 11.5617Z",
    fill: "#FFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 5C8.88071 5 10 3.88071 10 2.5C10 1.11929 8.88071 0 7.5 0C6.11929 0 5 1.11929 5 2.5C5 3.88071 6.11929 5 7.5 5Z",
    fill: "#9FA4A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedDotAlert);
export default __webpack_public_path__ + "static/media/red_dot_alert.68cbbc2bd14af1be58bc7ac6a4cfcbcc.svg";
export { ForwardRef as ReactComponent };